export default __webpack_public_path__ + "static/building-2d81202d8a5d7ea2f33112da99a55419.png";